import styled from 'styled-components';
import { sizes } from 'constants/theme';

export default styled.form`
  width: 100%;
  font-size: ${sizes.textSize};
`;
